module.exports = __webpack_public_path__ + "img/komunalakranj_racun_odjemnomesto.09eb7d03.jpg";